let notification = require('client/notification');
let xhr = require('client/xhr');
let Spinner = require('client/spinner');

const t = require('engine/i18n/t');

const config = require('config');
const {localCurrency, shopCurrency} = require('config');

// https://developer.paypal.com/sdk/js/configuration/#link-queryparameters
const loadPaypalScript = require("@paypal/paypal-js").loadScript;

t.i18n.add('payments', require('../../locales/' + config.lang + '.yml'));


/**
 * Get data from orderForm.getOrderData()
 * process payment, ask for more data if needed
 */
class FormPayment {

  constructor(orderForm, paymentMethodElem) {
    this.orderForm = orderForm;
    this.paymentMethodElem = paymentMethodElem;


    if (document.querySelector("[data-pay-paypal-buttons]")) {
      // paypal method enabled (and assuming the order not paid)
      loadPaypalScript({
        "client-id": config.paypalClientId,
        currency: shopCurrency,
        components: "buttons,marks"
      }).then(() => {
        let buttons = this.initPaypalButtons();

        buttons.render("[data-pay-paypal-buttons]");

        window.paypal.Marks().render(document.getElementById('input-paypal').parentNode.querySelector('.pay-method__paypal-marks'));
      });
    }

  }

  request(options) {
    let request = xhr(options);

    request.addEventListener('loadstart', function() {
      let onEnd = this.startRequestIndication();
      request.addEventListener('loadend', onEnd);
    }.bind(this));

    return request;
  }

  startRequestIndication() {

    this.paymentMethodElem.classList.add('modal-overlay_light');

    let spinner = new Spinner({
      elem:  this.paymentMethodElem.querySelector('[type="submit"]'),
      size:  'small',
      class: '',
      elemClass: 'button_loading'
    });
    spinner.start();

    return () => {
      this.paymentMethodElem.classList.remove('modal-overlay_light');
      if (spinner) spinner.stop();
    };

  }

  readPaymentFormValues() {
    let paymentData = {};

    [].forEach.call(this.paymentMethodElem.querySelectorAll('input,select,textarea'), function(elem) {
      if ( (elem.type == 'radio' || elem.type == 'checkbox') && !elem.checked) return;
      paymentData[elem.name] = elem.value;
    });

    return paymentData;
  }

  readOrderDataWithPayment() {

    let orderData = this.orderForm.getOrderData();
    if (!orderData) return;

    let paymentData = this.readPaymentFormValues();

    if (!paymentData.paymentMethod) {
      new notification.Error(t('payments.client.choose_payment_method'));
      return;
    }

    if (paymentData.paymentMethod == 'invoice') {
      if (!paymentData.invoiceCompanyName) {
        new notification.Error(t('payments.client.specify_company_name'));
        this.paymentMethodElem.querySelector('[name="invoiceCompanyName"]').focus();
        return;
      }
      if (document.querySelector('#invoice-agreement').checked || document.querySelector('#invoice-act').checked) {
        let contractHeadElem = document.querySelector('#invoice-contract-head')
        if (!contractHeadElem.dataset.prefilled && contractHeadElem.value == contractHeadElem.defaultValue) {
          new notification.Error("Введите, пожалуйста, шапку договора/акта.");
          contractHeadElem.focus();
          return;
        }

        let contractAddressElem = document.querySelector('#invoice-company-address')
        if (!contractAddressElem.dataset.prefilled && contractAddressElem.value == contractAddressElem.defaultValue) {
          new notification.Error("Введите, пожалуйста, юридический адрес.");
          contractAddressElem.focus();
          return;
        }

        let bankDetailsElem = document.querySelector('#invoice-bank-details')
        if (!bankDetailsElem.dataset.prefilled && bankDetailsElem.value == bankDetailsElem.defaultValue) {
          new notification.Error("Ведите, пожалуйста, реквизиты.");
          bankDetailsElem.focus();
          return;
        }

        let invoiceDocumentExchangeEdoElem = document.querySelector('#invoice-document-exchange-edo')

        if (invoiceDocumentExchangeEdoElem && invoiceDocumentExchangeEdoElem.checked) {
          let innElem = document.getElementById('invoice-inn');
          let inn = innElem.value.trim();
          if (!inn) {
            new notification.Error("Введите ИНН, пожалуйста.");
            innElem.focus();
            return;
          }
          if (inn.length != 10 && inn.length != 12 || /\D/.test(inn)) {
            new notification.Error("Некорректный ИНН (должно быть 10 или 12 цифр)");
            innElem.focus();
            return;
          }

          let kppElem = document.getElementById('invoice-kpp');
          if (kppElem.value == '') {
            new notification.Error("Введите КПП, пожалуйста (или 0, если его нет).");
            kppElem.focus();
            return;
          }
          let kpp = +kppElem.value;
          if (kpp != 0 && (kpp < 1e8 || kpp >= 1e10)) {
            new notification.Error("Некорректный КПП (должно быть 9 цифр)");
            kppElem.focus();
            return;
          }

        }

        let invoiceDocumentExchangeMailElem = document.querySelector('#invoice-document-exchange-mail');

        if (invoiceDocumentExchangeMailElem && invoiceDocumentExchangeMailElem.checked) {
          let fields = {
            "invoice-company-mail-index": "Индекс",
            "invoice-company-mail-who": "Кому",
            "invoice-company-mail-address": "Адрес"
          };

          for(let [id, name] of Object.entries(fields)) {
            let elem = document.getElementById(id);
            if (!elem.value) {
              new notification.Error(`Почтовый адрес: заполните поле ${name}.`);
              elem.focus();
              return;
            }
          }

          let index = document.getElementById('invoice-company-mail-index').value;
          if (index.length < 5 || index.length > 7) {
            new notification.Error(`Почтовый адрес: некорректный индекс (от 5 до 7 цифр).`);
            let elem = document.getElementById('invoice-company-mail-index');
            elem.focus();
            return;
          }
        }

      }
    }

    for (let key in paymentData) {
      orderData[key] = paymentData[key];
    }
    return orderData;
  }

  async submit() {
    let orderData = this.readOrderDataWithPayment();

    if (!orderData) {
      // couldn't read, error occured
      return;
    }

    return await this.sendPaymentRequest(orderData);
  }

  initPaypalButtons() {
    return window.paypal.Buttons({
      style: {
        layout: 'vertical',
        size: 'small',
        color:  'blue',
        label:  'pay',
        height: 40,
        tagline: false
      },
      // https://developer.paypal.com/docs/checkout/standard/customize/validate-user-input/
      // // onClick is called when the button is clicked
      // order validation, see also https://github.com/paypal/paypal-checkout-components/issues/139#issuecomment-558864009
      onClick: (data, actions) => {
        if (this.readOrderDataWithPayment()) {
          // if no errors, and the object is returned
          return true;
        } else {
          return false;
        }
      },
      // Call your server to set up the transaction
      createOrder: async (data, actions) => {

        let form, orderNumber;

        let submitResult = await this.submit();

        if (!submitResult) {
          throw new Error("Empty submitResult (must not happen, validate in onClick)");
        }

        form = submitResult.form;
        orderNumber = submitResult.orderNumber;

        return form.paypalOrderId;
      },
      onApprove: (data, actions) => {
        /*
        data example: {
          billingToken: null
          facilitatorAccessToken: "A21AANIGhT2tqhJ504cgKEa9Z_g-xw"
          orderID: "13S57819S21....."
          payerID: "H3R8....ZYU"
          paymentID: null
        } */

        let request = this.request({
          method: 'POST',
          url:  '/payments/paypal/capture',
          json: true,
          body: {
            paypalOrderId: data.orderID
          }
        });

        request.addEventListener('success', (event) => {

          let result = event.result;

          /* result example:
          {
            "id": "4FS73595UP9872822",
            "status": "COMPLETED",
            "purchase_units": [{
              "reference_id": "default",
              "shipping": {
                "name": {
                  "full_name": "..."
                },
                "address": { ... }
              },
              "payments": {
                "captures": [{
                  "id": "8N5393015K7333731",
                  "status": "COMPLETED",
                  "amount": {
                    "currency_code": "RUB",
                    "value": "1.00"
                  },
                  "final_capture": true,
                  "seller_protection": {
                    "status": "ELIGIBLE",
                    "dispute_categories": ["ITEM_NOT_RECEIVED", "UNAUTHORIZED_TRANSACTION"]
                  },
                  "seller_receivable_breakdown": {...}
                  "links": [...]
              }
            }],
            "payer": {
              "name": {
                "given_name": "...",
                "surname": "..."
              },
              "email_address": "...",
              "payer_id": "...",
              "address": {
                "country_code": "..."
              }
            },
            "links": [...]
          }
          */

          if (result.id !== data.orderID) {
            throw new Error("Result id must match order id (assertion failed)");
          }
          if (result.status != "COMPLETED") {
            new notification.Error(t('payments.client.error_start_again', {
              message: `Error ${result.status} Order ${result.id}`,
              email: config.ordersMail
            }));
            return;
          }

          actions.redirect(`${window.location.protocol}//${window.location.host}/payments/common/redirect/order/${result.orderNumber}`);
        });
      },
      onCancel: (paypalOrder) => {
        new notification.Error(t('payments.payment_failed'));
      },
      onError: (err) => {
        new notification.Error(t('payments.client.error_start_again', {
          message: err.message,
          email: config.ordersMail
        }));
        console.error(err);
      }

    });
  }

  async sendPaymentRequest(orderData) {
    // response status must be 200
    let request = xhr({
      method:         'POST',
      url:            '/payments/common/checkout',
      normalStatuses: [200, 403, 400, 503],
      body:           orderData,
      noDocumentEvents: true
    });

    // GA4
    // if (orderData.orderTemplate) {
    //   window.ga('ec:addProduct', {
    //     id:       this.orderForm.product,
    //     variant:  orderData.orderTemplate,
    //     price:    orderData.amount,
    //     quantity: 1
    //   });
    // }

    // window.ga('ec:setAction', 'checkout', {
    //   step:   1,
    //   option: orderData.paymentMethod
    // });

    // window.ga('send', 'event', {
    //   eventCategory: this.orderForm.product,
    //   eventAction: 'checkout-payment'
    // });

    let onEnd = this.startRequestIndication();

    return new Promise((resolve, reject) => {
      request.addEventListener('success', (event) => {

        let errorText;
        if (request.status == 403) {
          errorText = 'payments.client.error_start_again';
        } else if (request.status == 503) {
          errorText = 'payments.client.purchase_error'
        } else if (request.status == 400) {
          errorText = 'payments.client.maybe_purchase_error';
        }

        if (errorText) {
          new notification.Error(t(errorText, {
            message: (event.result.description || event.result.message || ''),
            email: config.ordersMail
          }));
          onEnd();
          reject();
          return;
        }

        let result = event.result;

        if (result.form) {
          // don't stop the spinner while submitting the form to the payment system!
          // (still in progress)

          // GA4
          // window.ga('ec:setAction', 'purchase', {
          //   id: result.orderNumber
          // });

          if (orderData.paymentMethod === 'paypal') {
            onEnd();
            resolve(result);
            return;
          } else if (result.form.redirect) {
            window.location.href = result.form.redirect;
          } else {
            let container = document.createElement('div');
            container.hidden = true;
            container.innerHTML = result.form;
            document.body.appendChild(container);

            container.firstChild.submit();
          }

        } else {
          console.error(result);
          onEnd();
          new notification.Error(t('payments.client.purchase_error', {
            email: config.ordersMail
          }));
        }
      });

      request.addEventListener('fail', event => {
        new notification.Error(event.reason);
        onEnd();
        reject();
      });
    })
  }
}

module.exports = FormPayment;
